/**
 * SpeedmasterCore.Config.js
 *
 * Lightweight utility module for SpeedmasterCore.
 * Provides helper functions used across entry points for safe model
 * attribute access and HTML decoding.
 *
 * Loyalty/rewards config moved to SpeedmasterLoyalty.Config.js.
 */
define('SpeedmasterCore.Config', [], function() {
    'use strict';

    /**
     * Safely read a model attribute — handles both Backbone models (.get())
     * and POJOs (direct property access).
     */
    function getModelAttr(model, attr) {
        if (model && typeof model.get === 'function') {
            return model.get(attr);
        }
        return model ? model[attr] : undefined;
    }

    /**
     * Decode HTML entities (from GlobalViews.Message.View.Ext).
     */
    function decodeHtml(html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

    return {
        getModelAttr: getModelAttr,
        decodeHtml: decodeHtml
    };
});
